import "./InputV1.css";
import InputDate from "./InputDate";
import InputError from "./InputError";
import InputHeader from "./InputHeader";
import { useEffect, useState } from "react";

const InputV1 = ({
  onClick,
  value,
  name,
  headerStr,
  placeholderText,
  errorStr,
  inputType = "text",
  linkStr,
  autocomplete = "off",
  autoComplete,
  isRequired,
  onChange,
  onClickChangePassword,
  onKeyPress,
  onPaste,
  onCopy,
  onCut,
  onBlur,
  maxLength,
  checkboxStr,
  className,
  labelStr,
  nombreRadio,
  desactivado,
  checkError,
  checked,
  deshabilitaFormulario,
  inputMode,
  pattern,
  refElement,
  radioClass,
  labelColor,
  disabledEjemplo,
  noHeight,
  id,
}) => {
  const [showError, setShowError] = useState(false);
  const [isUsed, setIsUsed] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [requerido, setRequerido] = useState(false);

  useEffect(() => {
    setShowError(checkError);
    if (!checkError) {
      setIsUsed(false);
    }
  }, [checkError]);

  useEffect(() => {
    if (isRequired !== undefined) {
      setRequerido(isRequired);
    }
  }, [isRequired]);

  const doOnChange = (e) => {
    if (onChange) {
      onChange(e);
    }
    setIsUsed(true);
  };

  const checkBlur = (e) => {
    setIsBlur(true);
    if (onBlur) onBlur(e);
  };

  const checkMostrarError = () => {
    let flag = false;
    if (requerido && !deshabilitaFormulario) {
      if (isUsed && showError) flag = true;
      //se elimino el blur momentaneamente
      // if (isBlur && !isUsed) flag = true;
      if (showError) flag = true;
    }
    return flag;
  };

  if (placeholderText) {
    if (!disabledEjemplo) {
      placeholderText = "ej: " + placeholderText;
    }
  }
  const render = (tipo) => {
    switch (tipo) {
      case "text":
      case "number":
      case "password":
      case "email":
      case "select":
        return (
          <>
            {/*agregue un div para mantener el espacio del error*/}
            <div>
              <InputHeader headerStr={headerStr} />
              <div className="ptur-inputContainer">
                <input
                  ref={refElement}
                  name={name}
                  type={inputType}
                  className={
                    !checkMostrarError()
                      ? className
                      : className + " ptur-input-borderError"
                  }
                  placeholder={placeholderText}
                  autoComplete={autoComplete || autocomplete || "off"}
                  required={isRequired}
                  onChange={doOnChange}
                  style={{
                    width: "100%",
                    height: 36,
                    paddingLeft: 8,
                    color: deshabilitaFormulario
                      ? "var(--color-grey45)"
                      : "var(--color-latex30)",
                  }}
                  onKeyPress={onKeyPress}
                  onPaste={onPaste}
                  onCopy={onCopy}
                  onCut={onCut}
                  value={value}
                  maxLength={maxLength}
                  disabled={desactivado || deshabilitaFormulario}
                  onBlur={checkBlur}
                  inputMode={inputMode}
                  pattern={pattern}
                />
                <InputError
                  onClickChangePassword={onClickChangePassword}
                  errorStr={checkMostrarError() ? errorStr : ""}
                  linkStr={linkStr}
                />
              </div>
            </div>
          </>
        );
      case "fecha":
        return (
          <>
            <div>
              <InputHeader headerStr={headerStr} />
              <InputDate
                placeholderText={placeholderText}
                onChange={onChange}
              ></InputDate>
              <InputError errorStr={errorStr} linkStr={linkStr} />
            </div>
          </>
        );
      case "check":
        return (
          <>
            <input
              type="checkbox"
              className={`${className} pointer checkBox`}
              onChange={onChange}
              id={"check" + id}
              checked={checked}
              onClick={onClick}
              name={name}
              value={value}
              autoComplete="off"
            />{" "}
            <label
              className="pointer ptur-label-checkbox rb16t"
              htmlFor={"check" + id}
            >
              {checkboxStr}
            </label>
          </>
        );
      case "radio":
        return (
          <>
            <input
              className="pointer radio"
              type="radio"
              id={"radio" + id}
              name={nombreRadio}
              defaultChecked={checked}
              onChange={onChange}
              defaultValue={value}
              // checked={checked}
              autoComplete="off"
            />
            <label
              className={`pointer ptur-label-radio ${radioClass} rb16l ${labelColor}`}
              // htmlFor={"radio" + id}
            >
              {labelStr}
            </label>
            <InputError
              errorStr={checkMostrarError() ? errorStr : ""}
              linkStr={linkStr}
            />
          </>
        );
      case "textarea":
        return (
          <>
            <textarea
              className={className}
              name={name}
              placeholder={placeholderText}
              onChange={onChange}
              value={value}
              maxLength={maxLength}
            >
              {value}
            </textarea>
          </>
        );
      default:
        return <></>;
    }
  };
  return (
    <div className="inputV1" style={noHeight && { height: "auto" }}>
      {render(inputType)}
    </div>
  );
};

export default InputV1;
